export default __webpack_public_path__ + "static/media/maya.19b0cd1a.png";